import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { Trans, useTranslation } from 'react-i18next';
import { Button } from '@cropler/ui-kit';

import styles from '../../styles/auth.module.scss';

import { AuthTitle } from '../../components';
import { useForgotPasswordMutation } from '../../store/api/auth';
import { RootState } from '../../store';

const ResetLink = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const { username } = useSelector((state: RootState) => state.auth);

  const [forgotPassword] = useForgotPasswordMutation();

  useEffect(() => {
    if (!username) {
      navigate('/login');
    }
  }, [username, navigate]);

  const resend = () => {
    forgotPassword({ username });
  };

  return (
    <>
      <div className={styles.formContainer}>
        <div className={styles.form}>
          <AuthTitle title={t('login.titleResetLink')} withBackButton />
          <p className={styles.description}>
            <Trans
              i18nKey="login.textResetLink"
              values={{ username: username }}
              components={{ span: <span className={styles.email} /> }}
            />
          </p>
          <Button
            type="primary"
            className={styles.buttonSubmit}
            size={'large'}
            onClick={() => navigate('/reset-password')}
          >
            {t('actions.resetPassword')}
          </Button>
          <div className={styles.resendContainer}>
            <div className={styles.resendContainerWrapper}>
              <span>{t('login.didntGetLetter')}</span>
              <Button onClick={resend} type="text">
                {t('actions.resend')}
              </Button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ResetLink;
